(function () {
  if (window.FGSStorefrontMoney) return;

  function format(cents, currency) {
    var code = String(currency || 'USD').toUpperCase();
    var amount = Number(cents || 0) / 100;
    var digits = code === 'IDR' ? 0 : undefined;
    var number;
    var symbol;

    try {
      var currencyFormat = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: code, currencyDisplay: 'narrowSymbol'
      });
      var options = currencyFormat.resolvedOptions();
      number = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: digits == null ? options.minimumFractionDigits : digits,
        maximumFractionDigits: digits == null ? options.maximumFractionDigits : digits
      }).format(amount);
      symbol = currencyFormat.formatToParts(amount).find(function (part) {
        return part.type === 'currency';
      }).value;
    } catch (error) {
      number = amount.toFixed(code === 'IDR' ? 0 : 2);
      symbol = code;
    }

    if (code === 'IDR') return 'Rp' + number;
    if (symbol.indexOf('$') !== -1) return symbol + number + ' ' + code;
    if (code === 'CHF' || code === 'SEK' || symbol === code || /[A-Za-z]/.test(symbol)) {
      return number + ' ' + code;
    }
    return symbol + number;
  }

  window.FGSStorefrontMoney = { format: format };
})();
